export const enum UserThemeEnum {
  LIGHT = 'LIGHT',
  DARK = 'DARK',
}
